<template>
  <div class="sidebar" :data-background-color="backgroundColor" :class="{ collapsed: collapsed }">
    <div class="sidebar-wrapper" id="style-3">
      <div class="sidebar-header">

        <!-- Logo collapsed -->
        <img
          v-show="collapsed"
          src="@/core/assets/img/logo_conectaa_branca.svg"
          alt="Logo"
          class="collapsed-logo"
        />

        <!-- Logo expandida -->
        <div class="logo" v-show="!collapsed">
          <router-link to="/dashboard">
            <a href="/dashboard" class="simple-text">
              <div class="logo-img">
                <img src="@/core/assets/img/Logo_spalm_branca.svg" alt="" />
              </div>
            </a>
          </router-link>
          <a href="javascript:void(0)" class="switch-trigger background-color">
            <span class="badge filter badge-white active" data-color="white"></span>
            <span class="badge filter badge-black" data-color="black"></span>
            <button class="sidebar-toggle-btn" @click="$emit('toggle-collapse')">
              <b-icon icon="layout-sidebar-inset" class="mr-1" font-scale="1.3" color="#fff" />
            </button>
          </a>
        </div>


      </div>
      <slot name="links"></slot>
      <menu-collapse
        style="overflow-y: auto; height: 80% !important;"
        v-if="filteredOptions.length > 0"
        :filteredOptions="filteredOptions"
        :collapsed="collapsed"
        @toggle-collapse="$emit('toggle-collapse')"

      />
      <div class="sidebar-footer">
      <transition name="fade-switch" mode="out-in">
          <ThemeSwitchHorizontal
  v-if="!collapsed"
  :value="isNight"
  @input="updateNight"
/>
<ThemeSwitchVertical
  v-else
  :value="isNight"
  @input="updateNight"
/>
</transition>
</div>
    </div>

  </div>
</template>

<!-- eslint-disable vue/require-slots-as-functions -->
<!-- eslint-disable vue/no-unused-components -->
<script>
import ThemeSwitchHorizontal from "@/components/ThemeSwitchHorizontal.vue";
import ThemeSwitchVertical from "@/components/ThemeSwitchVertical.vue";
import SidebarLink from "./SidebarLink";
import MenuCollapse from "../Menu/MenuCollapse.vue";

export default {
    props: {
    isNight: Boolean,
        title: {
            type: String,
            default: "SPALM",
        },
        sidebarLinks: {
            type: Array,
            default: () => [],
        },
        collapsed: {
        type: Boolean,
        default: false
        },
        autoClose: {
            type: Boolean,
            default: true,
        },
        backgroundColor: {
            type: String,
            default: "senado1",
            validator: (value) => {
                let acceptedValues = [
                    "white",
                    "black",
                    "darkblue",
                    "senado1",
                    "senado2",
                    "senado3",
                ];
                return acceptedValues.indexOf(value) !== -1;
            },
        },
        options: [],
    },
    provide() {
        return {
            autoClose: this.autoClose,
            addLink: this.addLink,
            removeLink: this.removeLink,
        };
    },
    components: {
        SidebarLink,
        MenuCollapse,
        ThemeSwitchHorizontal,
    ThemeSwitchVertical
    },
    computed: {
        arrowMovePx() {
            return this.activeLinkIndex;
        },
        filteredOptions() {
            return this.options;
        },
    },
    data() {
        return {
            linkHeight: 45,
            activeLinkIndex: 0,
            windowWidth: 0,
            isWindows: false,
            hasAutoHeight: false,
            links: [],
            moduleSelected:
                sessionStorage.getItem("last-module") ||
                (this.options[0] ? this.options[0].value : ""),
        };
    },
    methods: {
        findActiveLink() {
            this.links.forEach((link, index) => {
                if (link.isActive()) {
                    //this.activeLinkIndex = link.activeLinkIndex;
                    this.activeLinkIndex = index;
                }
            });
        },
          updateNight(val) {
    this.$emit('update:isNight', val); 
    },
        addLink(link) {
            const index = this.$slots.links.indexOf(link.$vnode);
            this.links.splice(index, 0, link);
        },
        removeLink(link) {
            const index = this.links.indexOf(link);
            if (index > -1) {
                this.links.splice(index, 1);
            }
        },
        getObjectByValue(array, key, value) {
            return array.filter((object) => object[key] === value);
        },
        changeContext(value) {
            const tempDepartamento = this.filteredOptions.find(
                (item) => item.value === value
            );
            const menu = tempDepartamento ? tempDepartamento.menu : null;
            if (menu) {
                sessionStorage.setItem("last-module", value);
                this.$root.$emit("moduleChanged", menu);
            }
        },
    },
    mounted() {
        setTimeout(() => this.changeContext(this.moduleSelected), 500);
    },
};
</script>
<style scoped >
.sidebar-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.sidebar-footer {
  margin-top: auto;         /* Empurra o footer para o final da coluna */
  display: flex;
  justify-content: center;  /* Centraliza horizontalmente */
  align-items: center;
  padding-bottom: 16px;     /* Espaço do rodapé, ajuste se quiser */
}
.fade-switch-enter-active, .fade-switch-leave-active {
  transition: opacity 0.3s;
}
.fade-switch-enter, .fade-switch-leave-to {
  opacity: 0;
}
.fade-switch-enter-to, .fade-switch-leave {
  opacity: 1;
}

</style>
